import universal from 'react-universal-component';

export default universal(() => import('./AccountInfo'));



// WEBPACK FOOTER //
// ./src/app/views/AccountInfo/index.js